import React, { useMemo } from 'react';
import classNames from 'classnames';
import EfImg from '@elem/ui/ef-img';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './index.module.scss';
import useSwiperAnimate from './useSwiperAnimate';
import { Pagination } from 'swiper';

interface NextGenSwiperProps {
    className?: string;
    list: {
        pc: string;
        pad?: string;
        h5?: string;
    }[];

    playOptions?: {
        // 轮播？
        autoPlay?: boolean;
        // 轮播时间
        duration?: number;
    };
}

const DEFAULT_PLAY_OPTIONS = {
    autoPlay: false,
    duration: 3000,
};

const NextGenSwiper: React.FC<NextGenSwiperProps> = ({ className, list, playOptions }) => {
    const currentPlayOptions = useMemo(
        () => ({
            ...DEFAULT_PLAY_OPTIONS,
            ...playOptions,
        }),
        [playOptions],
    );
    const { slideChangeHandle, hanldleMouseEnter, hanldleMouseLeave, changeSwiper } = useSwiperAnimate({
        length: list.length,
        duration: currentPlayOptions.duration,
        swiperClassName: 'ef-NextGen-swiper',
        autoPlay: currentPlayOptions.autoPlay,
    });

    return (
        <div className={classNames('ef-NextGen-swiper-container', className, styles.TheComp)}>
            <Swiper
                className="ef-NextGen-swiper"
                modules={[Pagination]}
                spaceBetween={0}
                loop
                autoplay
                initialSlide={0}
                pagination={list.length > 1 ? { clickable: true } : false}
                onSlideChange={slideChangeHandle}
                onSwiper={changeSwiper}
            >
                {list.map((item, idx) => (
                    <SwiperSlide
                        className={`ef-NextGen-swiper-item ef-NextGen-swiper-item-${idx}`}
                        onMouseEnter={hanldleMouseEnter}
                        onMouseLeave={hanldleMouseLeave}
                        key={idx}
                    >
                        <EfImg pc={item.pc} pad={item.pad} h5={item.h5} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};
export default NextGenSwiper;
